import React, { Component } from 'react';
import radium from 'radium';

import doubleCheeringStick from '../../static/images/Block4/doubleCheeringStick.png';
import home from '../../static/images/Block4/home.png';
import voteImg from '../../static/images/Block2/vote.jpg';
import vote2Img from '../../static/images/Block2/vote2.jpg';

import Type2Card from './Cards/Type2Card.jsx';

const styles = {
  wrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  cheeringSticker: {
    width: 135,
    height: 135,
    borderRadius: '50%',
    margin: '20px 50px',
    position: 'relative',
    backgroundColor: '#EE8356',
  },
  smallDoubleStick: {
    width: 60,
    position: 'absolute',
    left: 38,
    top: 26,
  },
  home: {
    width: 80,
    position: 'absolute',
    margin: 'auto',
    top: 10,
    right: 0,
    left: 0,
  },
  stickerText: {
    margin: 0,
    position: 'absolute',
    bottom: 21,
    left: 26,
    color: 'white',
    fontWeight: 600,
  },
  cardWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
};

class CardBlock extends Component {
  render() {
    return (
      <div style={styles.wrapper}>
        <div style={styles.cardWrapper}>
          <Type2Card
            title="5000 顆球去哪裡?"
            image={voteImg}
            facebookURL="https://www.facebook.com/556055591230516/posts/1085716838264386/" />
          <Type2Card
            title="百校贈球計畫"
            image={vote2Img}
            facebookURL="https://www.facebook.com/556055591230516/posts/1085716838264386/" />
        </div>
        <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/556055591230516/posts/1064278483741555/" style={styles.cheeringSticker}>
          <img style={styles.smallDoubleStick} src={doubleCheeringStick} alt="加油棒" />
          <img style={styles.home} src={home} alt="家" />
          <p style={styles.stickerText}>
            集氣這裡請!
          </p>
        </a>
      </div>
    );
  }
}

export default radium(CardBlock);
